import { useSortable } from '@dnd-kit/sortable'
import type { ComponentType } from 'react'

type WithSortableOptions<T> = {
  getId: (props: T) => string
}

export const withSortable =
  <T extends object>(WrappedComponent: ComponentType<T>, options: WithSortableOptions<T>) =>
  (props: T) => {
    const id = options.getId(props)

    const { attributes, listeners, setNodeRef } = useSortable({
      resizeObserverConfig: undefined,
      id,
    })

    return (
      <div className="w-full relative" ref={setNodeRef} {...attributes} {...listeners}>
        <WrappedComponent {...props} />
      </div>
    )
  }
